import React, { useRef } from "react";
import {
  motion,
  useScroll,
  useSpring,
  useTransform,
  useMotionTemplate,
  useReducedMotion,
} from "framer-motion";
import { useScrollScrub } from "../hooks/useScrollScrub";

const POSTER = `${process.env.PUBLIC_URL}/portfolio_intro_poster.jpg`;
const VIDEO = `${process.env.PUBLIC_URL}/portfolio_intro_metinsiz.mp4`;

const Titles = ({ style, children }) => (
  <motion.div className="hero__titles" style={style}>
    <h1 className="hero__name">
      <span>Mücahit</span>
      <span>
        <em>Tünel</em>
      </span>
    </h1>
    <div className="hero__meta">
      <span>
        <span lang="en">React Native</span> Geliştirici
      </span>
      <span lang="en">iOS · Android</span>
      <span>2020 → 2026</span>
    </div>
    {children}
  </motion.div>
);

const ScrollScrubHero = () => {
  const reduce = useReducedMotion();
  const sectionRef = useRef(null);
  const videoRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start start", "end end"],
  });
  const smooth = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    mass: 0.4,
  });

  useScrollScrub({ videoRef, progress: smooth, enabled: !reduce });

  const titlesOpacity = useTransform(smooth, [0, 0.72, 0.96], [1, 1, 0]);
  const titlesY = useTransform(smooth, [0, 1], [0, -48]);
  const titlesTransform = useMotionTemplate`translateY(${titlesY}px)`;
  const fillTransform = useMotionTemplate`scaleX(${smooth})`;
  const cueOpacity = useTransform(smooth, [0, 0.12], [1, 0]);

  if (reduce) {
    return (
      <section className="hero hero--static" id="top" ref={sectionRef}>
        <div className="hero__pin">
          <img className="hero__poster" src={POSTER} alt="" aria-hidden="true" />
          <div className="hero__scrim" />
          <Titles />
        </div>
      </section>
    );
  }

  return (
    <section className="hero" id="top" ref={sectionRef}>
      <div className="hero__pin">
        <video
          ref={videoRef}
          className="hero__video"
          src={VIDEO}
          poster={POSTER}
          muted
          playsInline
          preload="auto"
          disablePictureInPicture
          tabIndex={-1}
          aria-hidden="true"
        />
        <div className="hero__scrim" />
        <Titles style={{ opacity: titlesOpacity, transform: titlesTransform }}>
          <div className="hero__progress" aria-hidden="true">
            <motion.div
              className="hero__progress-fill"
              style={{ transform: fillTransform }}
            />
          </div>
        </Titles>
        <motion.div className="hero__cue" style={{ opacity: cueOpacity }}>
          Kaydır
        </motion.div>
      </div>
    </section>
  );
};

export default ScrollScrubHero;
